import { get, getRawValue } from '../../utils/get';
import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { renderStructureData } from './structured-data/render-structured-data';
export var IDs = {
    NAME: 'blog-tag.name',
    PAGE_URL: 'blog-tag.fullUrl',
    POST_COUNT: 'blog-tag.postCount',
    CREATED_DATE: 'blog-tag.created.date',
    DESCRIPTION: 'blog-tag.description',
    SD_DISABLED: 'blog-tag.disable-schema',
    SD_JSON_RENDER: 'blog-tag.structured-data.render',
};
var userVisible = [IDs.NAME, IDs.POST_COUNT, IDs.PAGE_URL];
var requiredSchemaVariables = [];
export default {
    IDs: IDs,
    getData: function (item) {
        var _a;
        var listItems = getRawValue(item, 'tag.listItems') || [];
        var sdDisabled = hasMissingSchemaVariables(requiredSchemaVariables, item) ||
            listItems.length <= 1;
        return _a = {},
            _a[IDs.NAME] = get(item, 'tag.name'),
            _a[IDs.PAGE_URL] = get(item, 'tag.fullUrl'),
            _a[IDs.POST_COUNT] = get(item, 'tag.postCount'),
            _a[IDs.CREATED_DATE] = get(item, 'tag.created'),
            _a[IDs.DESCRIPTION] = get(item, 'tag.description'),
            _a[IDs.SD_DISABLED] = sdDisabled,
            _a[IDs.SD_JSON_RENDER] = sdDisabled ? {} : renderStructureData(listItems),
            _a;
    },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
